export const CLEAR_REQ_PARAMS = 'CLEAR_REQ_PARAMS';
export const CLEAR_STATE = 'CLEAR_STATE';
export const SET_FAV_STATE = 'SET_FAV_STATE';
export const SET_FAV_PAGE = 'SET_FAV_PAGE';
export const SET_FAV_GROUP = 'SET_FAV_GROUP';
export const ADD_FAV_GROUP  = 'ADD_FAV_GROUP';
export const SET_FAV_DATA = 'SET_FAV_DATA';
export const RESET_FAV_DATA = 'RESET_FAV_DATA';
export const SET_FAV_ITEM_DATA = 'SET_FAV_ITEM_DATA';
export const SET_ADD_TO_CART = 'SET_ADD_TO_CART';
export const SET_ALL_ADD_TO_CART = 'SET_ALL_ADD_TO_CART';
export const DELETE_FAV_ITEM = 'DELETE_FAV_ITEM';
